import fornecedorRepository from './fornecedorRepository'
import materialRepository from './materialRepository'
import unidadeRepository from './unidadeRepository'
import fabricanteRepository from './fabricanteRepository'
import periodoContabilRepository from './periodoContabilRepository'
import aprovacaoEntradaRepository from './aprovacaoEntradaRepository'

export default baseUrl => {
    return {
        fornecedor: fornecedorRepository(baseUrl),
        material: materialRepository(baseUrl),
        unidade: unidadeRepository(baseUrl),
        fabricante: fabricanteRepository(baseUrl),
        periodoContabil: periodoContabilRepository(baseUrl),
        aprovacaoEntrada: aprovacaoEntradaRepository(baseUrl),
    }
}
